export const MIGRATION_STATUS = {
  noMigration: 0,
  inMigration: 1,
  migrationSuccess: 2,
};

export const LOCALSTORAGE_KEY = 'userMigration';
export const COOKIE_KEY = 'UNIFIED_ACCOUNT';
export const LOCAL_STORAGE_TIME_KEY = 'HOME_PAGE_USER_MIGRATION_TIME_KEY';
export const TRADE_LOCAL_STORAGE_TIME_KEY =
  'TRADE_PAGE_USER_MIGRATION_TIME_KEY';
